import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsTherapistMonthCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    personaName?: string
    month: number
    year: number
  }) => {
    return await repository.getOperationalCAAMetricsTherapistMonth(params)
  }
}
